// extracted by mini-css-extract-plugin
export default {"card":"Card_card__7Eml9","philosophy":"Card_philosophy__lSjYG","team":"Card_team__8+C3z"};